import ListItem from '@tiptap/extension-list-item';
import { TextSelection, AllSelection } from '@tiptap/pm/state';

const INDENT_PROPS = {
  MAX: 6,
  MIN: 0,
};

const updateIndentLevel = (tr, delta, editor) => {
  const { doc, selection } = tr;

  if (!doc || !selection) return tr;

  if (!(selection instanceof TextSelection || selection instanceof AllSelection)) {
    return tr;
  }

  const { from, to } = selection;

  doc.nodesBetween(from, to, (node, pos) => {
    if (node.type.name === 'listItem') {
      tr = setNodeIndentMarkup(tr, pos, delta, editor);
    }
    return true;
  });

  return tr;
};

const setNodeIndentMarkup = (tr, pos, delta, commands) => {
  if (!tr?.doc) return tr;

  const node = tr.doc.nodeAt(pos);
  if (!node) return tr;

  const minIndent = INDENT_PROPS.MIN;
  const maxIndent = INDENT_PROPS.MAX;

  const indent = Math.min(Math.max(minIndent, (node.attrs?.['data-list-indent'] || 0) + delta), maxIndent);

  if (indent === 0) {
    commands.toggleBulletList();
    return;
  }

  if (indent === node.attrs?.['data-list-indent']) return tr;

  const nodeAttrs = {
    ...node.attrs,
    'data-list-indent': indent,
  };

  return tr.setNodeMarkup(pos, node.type, nodeAttrs, node.marks);
};

const createIndentCommand = ({ delta }) => {
  return ({ state, dispatch, commands }) => {
    const { selection } = state;
    const { from } = selection;
    let { tr: originalTransaction } = state;
    let tr = originalTransaction.setSelection(selection);
    tr = updateIndentLevel(tr, delta, commands);

    if (tr?.docChanged) {
      dispatch && dispatch(tr);
      commands.focus(from);
      return true;
    } else {
      commands.focus(from);
    }

    return false;
  };
};

export default ListItem.extend({
  addAttributes() {
    return {
      'data-list-indent': {
        default: 1,
        renderHTML: (attributes) => {
          return {
            'data-list-indent': attributes['data-list-indent'],
          };
        },
      },
      'data-list-type': {
        default: 'bulleted',
        renderHTML: (attributes) => {
          return {
            'data-list-type': attributes['data-list-type'],
          };
        }
      }
    };
  },
  addCommands() {
    return {
      indent: () =>
        createIndentCommand({
          delta: 1,
        }),
      outdent: () =>
        createIndentCommand({
          delta: -1,
        }),
    };
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: (e) => {
        this.editor.commands.indent();
      },
      'Shift-Tab': () => this.editor.commands.outdent(),
    };
  },
});
